import { AvailableStagingsListContextProvider, GalleryStagingFlowContextProvider, GalleryStagingStackProvider } from '../../../common'
import { FC, useMemo } from 'react'
import { GalleryAdditionalVisualsContextProvider, GalleryAssignmentContextProvider, GalleryDealContextProvider, GalleryNavigationContextProvider, GalleryOrderContextProvider, GalleryProductContextProvider, GalleryVirtualVisitContextProvider, GalleryVisualSelectionContextProvider, GalleryVisualTypeContextProvider, GalleryVisualsContextProvider, GalleryVisualsDownloadArchiveContextProvider, GalleryVisualsEditingStackProvider, GalleryVisualsFileAPIProvider, GalleryVisualsMetaContextProvider } from '../../contexts'
import { Outlet, useParams } from 'react-router-dom'

import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { ClientGalleryContextProvider } from './contexts'
import { GalleryStagingContextProvider } from 'components/pages/Gallery/pages/GalleryStaging'
import NotFound from 'components/pages/General/NotFound/NotFound'
import { PageTransition } from 'utils/animations'
import { ThreadContextProvider } from 'components/common/Threads/context'

export const ClientGallery: FC = () => {
  const { id } = useParams<{ id?: string }>()
  const assignmentId = useMemo(() => id || undefined, [id])

  if (!assignmentId) return <NotFound />

  return (
    <BKBNThemeWrapper>
      <GalleryAssignmentContextProvider assignmentId={assignmentId}>
        <GalleryDealContextProvider assignmentId={assignmentId} keepPreviousData={true}>
          <GalleryVisualTypeContextProvider assignmentId={assignmentId}>
            <GalleryProductContextProvider assignmentId={assignmentId}>
              <GalleryOrderContextProvider assignmentId={assignmentId}>
                <GalleryVisualsMetaContextProvider assignmentId={assignmentId}>
                  <GalleryVisualsFileAPIProvider assignmentId={assignmentId}>
                  <GalleryVisualsContextProvider assignmentId={assignmentId}>
                    <GalleryVirtualVisitContextProvider assignmentId={assignmentId}>
                      <GalleryVisualSelectionContextProvider assignmentId={assignmentId}>
                        <GalleryAdditionalVisualsContextProvider assignmentId={assignmentId}>
                          <GalleryVisualsDownloadArchiveContextProvider assignmentId={assignmentId}>
                            <GalleryVisualsEditingStackProvider assignmentId={assignmentId}>
                              <GalleryStagingStackProvider>
                                <GalleryStagingFlowContextProvider>
                                  <GalleryStagingContextProvider>
                                    <AvailableStagingsListContextProvider>
                                      <ThreadContextProvider assignmentId={assignmentId}>

                                        <ClientGalleryContextProvider assignmentId={assignmentId}>
                                          <GalleryNavigationContextProvider>

                                            <PageTransition>
                                              <Outlet></Outlet>
                                            </PageTransition>

                                          </GalleryNavigationContextProvider>
                                        </ClientGalleryContextProvider>

                                      </ThreadContextProvider>
                                    </AvailableStagingsListContextProvider>
                                  </GalleryStagingContextProvider>
                                </GalleryStagingFlowContextProvider>
                              </GalleryStagingStackProvider>
                            </GalleryVisualsEditingStackProvider>
                          </GalleryVisualsDownloadArchiveContextProvider>
                        </GalleryAdditionalVisualsContextProvider>
                      </GalleryVisualSelectionContextProvider>
                    </GalleryVirtualVisitContextProvider>
                  </GalleryVisualsContextProvider>
                  </GalleryVisualsFileAPIProvider>
                </GalleryVisualsMetaContextProvider>
              </GalleryOrderContextProvider>
            </GalleryProductContextProvider>
          </GalleryVisualTypeContextProvider>
        </GalleryDealContextProvider>
      </GalleryAssignmentContextProvider>
    </BKBNThemeWrapper>
  )
}
